<template>
  <ol class="ec-list">
    <li
      v-for="item in items"
      :key="item.id"
      class="ec-list__item"
      :style="{ '--ec-depth': item.depth }"
    >
      <a
        class="ec-list__link"
        :class="{ 'ec-list__link--active': item.id === activeId }"
        :href="`#${item.id}`"
        :title="item.text"
        :aria-current="item.id === activeId ? 'true' : undefined"
        @click="onClick($event, item.id)"
      >
        {{ item.text }}
      </a>
    </li>
  </ol>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeId: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["select"]);

const onClick = (event, id) => {
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  emit("select", id);
};
</script>

<style lang="scss" scoped>
.ec-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ec-list__item {
  margin: 0;
}

.ec-list__link {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0.3rem 0.5rem;
  padding-left: calc(0.5rem + var(--ec-depth, 0) * 0.85rem);
  border-radius: 6px;
  color: rgb(var(--v-theme-on-surface));
  font-size: 0.9rem;
  line-height: 1.3;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.ec-list__link:hover,
.ec-list__link:focus-visible {
  background: rgba(var(--v-theme-primary), 0.08);
  outline: none;
}

.ec-list__link--active {
  background: rgba(var(--v-theme-primary), 0.1);
  box-shadow: inset 2px 0 0 rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-primary));
  font-weight: 600;
}
</style>
